export function SuccessContact() {
    return (
        <div style={{ height: "60vh" }}>
            <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15vh", gap: "3vh" }}>
                <h1 style={{ textAlign: "center" }}>Merci d'avoir pris contact avec nous!</h1>
                <div style={{ width: "80%", textAlign: "center" }}>Nous reviendrons vers vous dans les plus brefs délais.</div>
            </div>
        </div>
    )
}